import * as React from 'react';
import { Link } from 'react-router-dom';
import { GetCompanionList } from '../../../actions/CompanionActions';
import CompanionStore from '../../../stores/CompanionStore';

class CompanionSidebar extends React.Component {
  constructor() {
    super();
    this.state = {
      compList: [],
    };

    this.onReceiveCompanionChange = this.onReceiveCompanionChange.bind(this);
  }

  componentDidMount() {
    CompanionStore.addChangeListener(this.onReceiveCompanionChange);
    GetCompanionList();
  }

  componentWillUnmount() {
    CompanionStore.removeChangeListener(this.onReceiveCompanionChange);
  }

  onReceiveCompanionChange() {
    let comps = CompanionStore.getCompanionList();
    this.setState({ compList: comps });
  }

  render() {
    let listOfISs;
    if (this.state.compList !== undefined) {
      listOfISs = this.state.compList.map((comp) => (
        <Link
          to={'/Admin/CompanionView/' + comp.id}
          key={comp.id}
          className='sidebar-link'
        >
          {comp.companionName}
        </Link>
      ));
    } else {
      listOfISs = <div />;
    }
    return (
      <div
        className='d-flex flex-column p-3 text-white bg-dark'
        style={{ height: '100%', width: '245px' }}
      >
        <Link
          to='/Admin/CompanionTables'
          className='d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none'
        >
          <span className='fs-4'>
            <i className='fa-solid fa-table' />
            {'   '}
            Companion Tables
          </span>
        </Link>
        <hr />
        {listOfISs}
        <hr />
      </div>
    );
  }
}

export default CompanionSidebar;
